//Imports node_modules
import React, { useContext } from 'react'
import { Link } from "react-router-dom";

//Imports Css
import './ListItemGroupDelivery.css'

//Import Data
import { globalFunctions } from '../../../data/GlobalFunctions'

//Import Images
import trashcan from '../../../imgs/Trash.svg';
import prodSvg from '../../../imgs/prod.svg';


//Esta Class é responsavel por gerar os items a inserir dentro das tabelas
const ListItemGroupDelivery = (params) => {

    //Variaveis locais
    const {
        advancedClick
    } = useContext(globalFunctions);

    var backColor = '#EFEFEF'
    var textColor = '#164978'

    var teste = 0
    switch (params.step.cttType) {
        case 1:
            backColor = '#E4EDF4'
            break;
        case 2:
            backColor = '#CBEBAD'
            break;
        case 3:
            backColor = '#E4EDF4'
            break;
        case 4:
            backColor = '#E4EDF4'
            break;
        case 5:
            backColor = '#FCE3AC'
            break;
        default:
            break;
    }

    return (
        <li key={params.chave} className={'RdashListItem'} style={{ backgroundColor: backColor }}>
            <Link
                to="#"
            >
                <div className='listItemGroupMainFlex'>
                    <div className='listItemGroupIcon'>
                        <img
                            loading="lazy"
                            src={prodSvg}
                            className='mainSvg'
                            alt="Prod." />
                    </div>

                    <div className='listItemGroupText' >
                        <span style={{ color: textColor }}>
                            {params.step.cct}
                        </span>
                    </div>

                    <div className='listItemGroupDates'>
                        <span style={{ color: textColor, textDecoration: 'none', }}>
                            Inicio: {params.step.horai}  <br></br> Fim: {params.step.horaF}
                        </span>
                    </div>

                    <div className='listItemGroupoptions'>
                        {params.step.type === 'project' ?
                            <img
                                loading="lazy"
                                src={trashcan}
                                className='trasgSvg'
                                alt="Lixo"
                                onClick={e => advancedClick(e, (e => params.step.onclick()))}
                                onTouchStart={e => advancedClick(e, (e => params.step.onclick()))}
                                onTouchEnd={e => advancedClick(e, (e => params.step.onclick()))}
                                onMouseDown={e => advancedClick(e, (e => params.step.onclick()))}
                                onMouseUp={e => advancedClick(e, (e => params.step.onclick()))} />
                            :
                            false
                        }
                    </div>
                </div>
            </Link>
        </li>
    )
}

export default React.memo(ListItemGroupDelivery)